<template>
	<!--父级路由和子级路由的选择-->
	<router-view v-if="$route.path !== '/treasure'"></router-view>

	<div class="treasure" v-else>
		<content-wrapper :wrapper="wrapper"></content-wrapper>
		<line-card :recommend="recommend"></line-card>
		<block-card :products="products"></block-card>
	</div>
</template>

<script>
import ContentWrapper from '@/components/treasure/ContentWrapper.vue';
import LineCard from '@/components/treasure/LineCard.vue';
import BlockCard from '@/components/treasure/BlockCard.vue';

export default {
	components: {ContentWrapper, LineCard, BlockCard},
	data(){
		return {
			wrapper:[
				{image:require('.././assets/images/maikefeng.png'),name:'欢迎~',content:'幻音阁，专注于为厅主、歌手提供便捷的软件工具页面，我们的目标是打造全方位一体化的语音工具。2024，希望大家赚大钱！',url:''},
			],
			recommend:[
        {id:'001',image:require('.././assets/images/cool_card.png'),name:'扣排器',content:'热门',url:''},
        {id:'002',image:require('.././assets/images/cool_card.png'),name:'高级任务',content:'最新',url:''},
        // {id:'002',image:require('.././assets/images/cool_card.png'),name:'扣排市场',content:'热门',url:''},
        // {id:'001',image:require('.././assets/images/cool_card.png'),name:'颜色剪切板',content:'热门',url:''},
				// {id:'002',image:require('.././assets/images/identification_photo.png'),name:'证件照制作',content:'在线',url:''},
				// {id:'003',image:require('.././assets/images/Image_ashing.png'),name:'图片灰化',content:'快捷',url:''},
			],
			products:[
        {id:'010',image:require('.././assets/images/cool_card.png'),name:'扣排器',recommend:'一种很新的识别方式，所有文本都能处理',url:''},
        {id:'011',image:require('.././assets/images/cool_card.png'),name:'高级任务',recommend:'自定义编辑机器人的任务',url:''},
        // {id:'011',image:require('.././assets/images/cool_card.png'),name:'扣排市场',recommend:'无限的扣排方式，自由选择',url:''},
				// {id:'007',image:require('.././assets/images/gallery.png'),name:'画廊',recommend:'这是一段属于该产品的专属介绍！！！',url:''},
				// {id:'018',image:require('.././assets/images/time_table.png'),name:'数字时钟',recommend:'这是一段属于该产品的专属介绍！！！',url:''},
				// {id:'004',image:require('.././assets/images/change_skin.png'),name:'一键换肤',recommend:'这是一段属于该产品的专属介绍！！！',url:''},
				// {id:'005',image:require('.././assets/images/input_skin.png'),name:'输入皮肤',recommend:'这是一段属于该产品的专属介绍！！！',url:''},
			]


		}
	}
}
</script>

<style lang="scss" scoped>

.treasure {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	color: #fff;
	padding: 20px 40px;
	height: 100%;
	overflow: auto;
	background-color: rgba(16 18 27 / 10%);
	@media screen and (max-width: 510px) {
		padding: 20px;
	}

}


</style>>

